import DeletionLogsIndex from '../views/DeletionLogs/Index'

let routes = {
    path: '/deletion-logs',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/deletion-logs',
            name: 'deletion-logs',
            component: DeletionLogsIndex,
            meta: {
                access_nivel: [2, 6],
                breadcrumb: [
                    {
                        text: 'Auditoria de Exclusões',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
